RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Reactivate = Backbone.Model.extend({
        url: function () {
            const me = this;
            return `/api/account/${me.get('accountId')}/reactivate`;
        }
    });
});
